import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import * as SedeService from 'services/sede.service'

const fetcher = () => SedeService.obtenerAsSelect().then(({ data }) => data)

const SedeSelect = ({ titulo, ...props }) => {
  const { data: sedes } = useSwr('select_sedes', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  return (
    <Form.Select {...props}>
      <option value=''>{titulo || 'Seleccionar'}</option>
      {sedes.map((val, key) => (
        <option key={key} value={val._id}>
          {val.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(SedeSelect)
